<template>
  <div class="row" style="overflow: hidden;">
    <div class="flex xs12 md12 lg6">
      <div class="auth-layout row align-content--center">
        <div class="flex xs12  flex-center">
          <router-link class="py-1 flex-center" to="/">
            <!-- <va-icon-vuestic /> -->
              <img src="../../assets/imgs/newlogo.png">
          </router-link>
        </div>

        <div class="flex xs12 pa-3">
          <div class="d-flex justify--center">
            <va-card class="auth-layout__card">
              <va-tabs
                v-model="tabIndex"
                center
              >
                <va-tab>{{ $t('auth.login') }}</va-tab>
                <!-- <va-tab>{{ $t('auth.createNewAccount') }}</va-tab> -->
              </va-tabs>

              <va-separator/>

              <div class="pa-3">
                <router-view/>
              </div>
            </va-card>
          </div>
        </div>
      </div>
    </div>
    <div class="flex md12 lg6 banner hidden-sm-and-down">
      <div class="img-container">
        <img src="../../assets/imgs/trans.png" width="100%" height="100%">
      </div>       
    </div>
  </div>
</template>

<script>
import VaIconVuestic from '../../iconset/VaIconVuestic'

const tabs = [
  'login',
  'signup',
]

export default {
  name: 'AuthLayout',
  components: { 
    VaIconVuestic
  },
  data () {
    return {
      selectedTabIndex: 0,
      tabTitles: ['login', 'createNewAccount'],
    }
  },
  computed: {
    tabIndex: {
      set (tabIndex) {
        this.$router.push({ name: tabs[tabIndex] })
      },
      get () {
        return tabs.indexOf(this.$route.name)
      },
    },
  },
  methods:{
    clickPlay(){
      console.log("clicked")
    }
  }
}
</script>

<style lang="scss">
body {
  overflow-x: hidden;
  overflow-y: hidden;
}

.auth-layout {
  min-height: 100vh;
  background-image: linear-gradient(to right, #00a54f, #00a54f);

  &__card {
    width: 100%;
    max-width: 600px;
  }

  &__options {
    @include media-breakpoint-down(xs) {
      flex-direction: column;
    }
  }
}

.img-container {
  text-align: center;
  display: block;
  padding-top: 0%;
}

@media (max-width: 767px) {
  .img-container {
    display: none;
  }
}

.banner {
  //background: url('../../assets/imgs/bg_color.png');
  background-repeat: repeat;
  background-blend-mode: screen;
  background-color: #f7f7f7;
  position: relative;
}
</style>
